<div class="qr-scanner-fullscreen" [class.embedded-mode]="isEmbedded">
  <!-- Top Bar -->
  @if (showTopBar()) {
    <div class="top-bar">
      <div class="row g-0 align-items-center w-100">
        <!-- Coluna Esquerda -->
        <div class="col-auto">
          <div class="d-flex align-items-center gap-2">
            <button class="top-bar-btn" (click)="closeScanner.emit()" aria-label="Fechar">
              <mat-icon>close</mat-icon>
            </button>
            @if (supportsFlash) {
              <button class="top-bar-btn" (click)="toggleFlash()" [class.active]="flashEnabled" aria-label="Flash">
                <mat-icon>{{ flashEnabled ? 'flash_on' : 'flash_off' }}</mat-icon>
              </button>
            }
          </div>
        </div>
        <!-- Coluna Central - Toggle/Título (sempre centralizado) -->
        <div class="col d-flex justify-content-center">
          <!-- Título (opcional) -->
          @if (title && !headerContent) {
            <div class="scanner-title text-white fw-bold">{{ title }}</div>
          }
          <!-- Slot para conteúdo customizado do header -->
          @if (headerContent) {
            <ng-container *ngTemplateOutlet="headerContent" />
          }
        </div>
        <!-- Coluna Direita -->
        <div class="col-auto">
          @if (supportsMultipleCameras) {
            <button class="top-bar-btn" (click)="switchCamera()" aria-label="Trocar câmera">
              <mat-icon>flip_camera_ios</mat-icon>
            </button>
          }
          <!-- No painel embutido o espelhar mora na barra de baixo, sempre.
               Aqui ele só aparece no fullscreen quando não há o que trocar. -->
          @if (!supportsMultipleCameras && !isEmbedded) {
            <button class="top-bar-btn" (click)="toggleMirror()" [class.active]="isMirrored" aria-label="Espelhar câmera">
              <mat-icon>flip</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- Scanning Area -->
  <div class="scanning-area" (click)="focarManualmente()">
    <div id="qr-reader" #qrReader class="qr-reader"></div>

    <!-- Preview quando há erro de câmera (modo embedded) -->
    @if (hasCameraError && isEmbedded) {
      <div class="camera-preview-placeholder">
        <div class="preview-content">
          <mat-icon class="preview-icon">no_photography</mat-icon>
          <!-- "Câmera não disponível" soava como defeito nosso. O texto diz de
               quem é a permissão e aponta a saída que sempre existe. -->
          <p class="preview-text">Câmera bloqueada</p>
          <p class="preview-hint">Libere o acesso à câmera nas permissões do navegador, ou digite o código do ingresso.</p>
        </div>
      </div>
    }

    <!-- Scanning Frame -->
    <div class="scanning-frame" [class.hidden]="hasCameraError && isEmbedded">
      <div class="corner corner-top-left"></div>
      <div class="corner corner-top-right"></div>
      <div class="corner corner-bottom-left"></div>
      <div class="corner corner-bottom-right"></div>
      <div class="scanning-line"></div>
    </div>

    <!-- Error Message (apenas se não for modo embedded) -->
    @if (errorMessage && !isEmbedded) {
      <div class="error-message">
        <p>{{ errorMessage }}</p>
      </div>
    }
  </div>

  <!-- Zoom Slider -->
  @if (supportsZoom && !hideControls() && !(isEmbedded && hasCameraError)) {
    <div class="zoom-controls">
      <span class="zoom-icon">-</span>
      <input
        type="range"
        class="zoom-slider"
        min="1"
        max="3"
        step="0.1"
        [value]="zoomLevel"
        (input)="onZoomChange($event)"
        aria-label="Zoom"
        >
      <span class="zoom-icon">+</span>
    </div>
  }

  <!-- Último Código Lido -->
  @if (ultimoCodigoLido && !hideControls()) {
    <div class="ultimo-codigo-container">
      <div class="ultimo-codigo-box">
        <label class="ultimo-codigo-label">Último código lido:</label>
        <div class="ultimo-codigo-value">{{ ultimoCodigoLido }}</div>
      </div>
    </div>
  }

  <!-- Bottom Navigation -->
  @if (!hideControls() && !(isEmbedded && hasCameraError)) {
    <div class="bottom-nav">
      <!-- Slot para conteúdo customizado do bottom-nav -->
      @if (bottomNavContent) {
        <ng-container *ngTemplateOutlet="bottomNavContent" />
      }
      <!-- Bottom-nav padrão (quando não há conteúdo customizado) -->
      @if (!bottomNavContent) {
        <button class="nav-btn" (click)="fileInput.click()" aria-label="Abrir galeria">
          <input #fileInput  hidden type="file" id="qr-input-file" accept="image/*" (change)="onFileSelected($event)">
          <mat-icon>image</mat-icon>
        </button>
        <button class="nav-btn nav-btn-primary" (click)="toggleModoEntrada()" [attr.aria-label]="modoEntrada === 'scan' ? 'Digitar código' : 'Escanear'">
          <mat-icon>{{ modoEntrada === 'scan' ? 'keyboard' : 'qr_code_scanner' }}</mat-icon>
          <!-- No painel embutido o botão é pílula e cabe o rótulo; no
               fullscreen ele é o círculo flutuante, onde o rótulo não cabe. -->
          @if (isEmbedded) {
            <span>{{ modoEntrada === 'scan' ? 'Digitar código' : 'Escanear' }}</span>
          }
        </button>
        <!-- Espelhar sempre disponível no embutido. As duas condições antigas
             se anulavam: a barra só mostrava sem múltiplas câmeras, e o topo
             trocava o espelhar por "Trocar câmera" quando havia — com webcam
             que reporta mais de uma, não sobrava botão nenhum. -->
        @if (isEmbedded) {
          <button class="nav-btn" (click)="toggleMirror()" [class.active]="isMirrored" aria-label="Espelhar câmera">
            <mat-icon>flip</mat-icon>
          </button>
        }
        @if (showHistory()) {
          <button class="nav-btn" (click)="toggleHistorico()" [class.active]="showHistorico" aria-label="Histórico">
            <mat-icon>history</mat-icon>
            <span class="nav-label">Histórico</span>
          </button>
        }
      }
    </div>
  }

  <!-- Histórico Desktop - Sidebar -->
  @if (showHistorico && table) {
    <div class="historico-sidebar d-none d-md-block">
      <div class="sidebar-header">
        <h4>Histórico</h4>
        <button class="close-btn" (click)="fecharHistorico(); $event.stopPropagation()" aria-label="Fechar" type="button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <!-- Slot para conteúdo customizado do header da tabela -->
      @if (tableHeaderContent) {
        <div class="sidebar-header-content">
          <ng-container *ngTemplateOutlet="tableHeaderContent" />
        </div>
      }
      <div class="sidebar-search">
        <div class="input-group input-group-sm">
          <input
            type="text"
            class="form-control"
            [formControl]="filtroHistorico"
            [dg-dynamic-group]="tableConfig()?.filters?.group || 'historicoCheckpoint'"
            paramName="filtro"
            placeholder="Buscar por código..."
            >
          <span class="input-group-text">
            <mat-icon>search</mat-icon>
          </span>
        </div>
      </div>
      @if (!!table) {
        <div class="sidebar-content">
          @if (!!table) {
            <dg-table dg-dynamic-table [dynamicTable]="table" classes="default-table">
              <ng-template #tableLoader>
                <custom-loader-table />
              </ng-template>
            </dg-table>
          }
          @if (!!table) {
            <div class="sidebar-pagination">
              <dg-paginator [pageSizeOptions]="[10, 25, 50, 100]" dg-dynamic-paginator [dynamicTable]="table" />
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Diálogo de entrada manual -->
  @if (showInputDialog) {
    <div class="input-dialog-overlay" (click)="cancelarCodigoManual()">
      <div class="input-dialog" (click)="$event.stopPropagation()">
        <div class="input-dialog-header">
          <h4>Digitar Código</h4>
          <button class="close-dialog-btn" (click)="cancelarCodigoManual()" aria-label="Fechar">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="input-dialog-body">
          <label class="input-label">Código:</label>
          <input
            type="text"
            class="form-control input-codigo"
            [formControl]="codigoManual"
            placeholder="Digite o código"
            (keyup.enter)="confirmarCodigoManual()"
            autofocus
            >
        </div>
        <div class="input-dialog-footer">
          <button class="btn btn-secondary" (click)="cancelarCodigoManual()">Cancelar</button>
          <button class="btn btn-primary" (click)="confirmarCodigoManual()" [disabled]="!codigoManual.value?.trim()">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Histórico Mobile - Tela Fullscreen -->
  @if (showHistorico && table) {
    <div class="historico-mobile d-block d-md-none" (scroll)="onHistoricoScroll($event)">
      <div class="historico-mobile-header">
        <button class="back-btn" (click)="fecharHistorico(); $event.stopPropagation()" aria-label="Voltar" type="button">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h4 class="historico-title">Histórico</h4>
        <button class="menu-btn" aria-label="Menu">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <!-- Slot para conteúdo customizado do header da tabela (tabs, etc) -->
      @if (tableHeaderContent) {
        <div class="historico-header-content">
          <ng-container *ngTemplateOutlet="tableHeaderContent" />
        </div>
      }
      <!-- Busca -->
      <div class="historico-search">
        <div class="input-group input-group-sm">
          <input
            type="text"
            class="form-control"
            [formControl]="filtroHistorico"
            [dg-dynamic-group]="tableConfig()?.filters?.group || 'historicoCheckpoint'"
            paramName="filtro"
            placeholder="Buscar por código..."
            >
          <span class="input-group-text">
            <mat-icon>search</mat-icon>
          </span>
        </div>
      </div>
      <!-- Container da Lista de Histórico -->
      <div class="historico-list-container">
        <!-- Lista de Histórico -->
        @if (historicoItems.length > 0) {
          <div
            class="historico-list"
            #historicoList
            >
            <!-- Template customizado para cada item do histórico -->
            @if (historicoListItem) {
              @for (item of historicoItems; track item) {
                <ng-container *ngTemplateOutlet="historicoListItem; context: { $implicit: item }" />
              }
            } @else {
              @for (item of historicoItems; track item) {
                <div class="historico-item">
                  <div class="historico-item-icon">
                    <mat-icon>qr_code</mat-icon>
                  </div>
                  <div class="historico-item-content">
                    <div class="historico-item-url">{{ $any(item)?.codigo || '--' }}</div>
                    <div class="historico-item-data">{{ $any(item)?.nomeParticipante || '--' }}</div>
                  </div>
                  <div class="historico-item-content">
                    <div class="historico-item-tipo">
                      @if ($any(item)?.tipo === 'ENTRADA') {
                        <span style="color: #4CAF50; font-weight: 600;">ENTRADA</span>
                      }
                      @if ($any(item)?.tipo === 'SAIDA') {
                        <span style="color: #f44336; font-weight: 600;">SAÍDA</span>
                      }
                    </div>
                  </div>
                  <div class="historico-item-date">
                    {{ formatDate($any(item)?.data) }}
                  </div>
                  <button class="historico-item-delete" aria-label="Excluir">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            }
          </div>
        }
        <!-- Loading mais itens -->
        @if (carregandoMaisItens) {
          <div class="historico-loading">
            <div class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <span class="ms-2 text-white-50">Carregando mais itens...</span>
            </div>
          </div>
        }
        <!-- Mensagem vazia -->
        @if (historicoItems.length === 0 && !carregandoMaisItens) {
          <div class="historico-empty">
            <div class="text-center py-5">
              <h4 class="empty-title">SEM REGISTROS</h4>
              <p class="empty-subtitle">Nenhum registro encontrado.</p>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

